const state = {
  items: [],
  fnb_price: {
    total_tax: 0,
    total_price: 0,
  },
  fnb_net_amount: 0,
  cinema_id: null,
};

const mutations = {
  SET_PENDING_FNB_CART: (state, payload) => {
    state.items = payload.items || [];
    state.fnb_price = payload.fnb_price || { total_tax: 0, total_price: 0 };
    state.fnb_net_amount = payload.fnb_net_amount || 0;
    state.cinema_id = payload.cinema_id || null;
  },
  CLEAR_PENDING_FNB_CART: (state) => {
    state.items = [];
    state.fnb_price = { total_tax: 0, total_price: 0 };
    state.fnb_net_amount = 0;
    state.cinema_id = null;
  },
};

const actions = {
  savePendingFnbCart: ({ commit }, payload) => {
    commit("SET_PENDING_FNB_CART", payload);
  },
  clearPendingFnbCart: ({ commit }) => {
    commit("CLEAR_PENDING_FNB_CART");
  },
};

const getters = {
  GET_PENDING_FNB_CART: (state) => state,
  HAS_PENDING_FNB_CART: (state) =>
    Array.isArray(state.items) && state.items.length > 0,
  GET_PENDING_FNB_ITEMS: (state) => state.items,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/PendingFnbCart.js